import { AppBar, Box, styled, Toolbar } from '@mui/material';
import { HORIZONTAL_NAVIGATION_Z_INDEX } from 'components/HorizontalNavigation';
import { FIXED_HEADER_STYLES, PROGRESS_BAR_HEIGHT, TOOLBAR_HEIGHT } from 'theme';

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  ...FIXED_HEADER_STYLES,
  top: 0,
  zIndex: HORIZONTAL_NAVIGATION_Z_INDEX,

  '& .MuiToolbar-gutters': {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const StyledToolbar = styled(Toolbar)(() => ({
  minHeight: `${TOOLBAR_HEIGHT}px !important`,
}));

const TitleContainer = styled(Box)(() => ({
  overflow: 'hidden',
}));

const ProgressBar = styled(Box)(() => ({
  backgroundColor: 'transparent',
  height: `${PROGRESS_BAR_HEIGHT}px`,
  position: 'fixed',
  zIndex: HORIZONTAL_NAVIGATION_Z_INDEX - 1,
  ...FIXED_HEADER_STYLES,
}));

const StyledBoxContainer = styled(Box)(({ theme }) => ({
  margin: `-${theme.spacing(2)}`,
  width: `calc(100% + ${theme.spacing(4)}) !important`,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export { StyledAppBar, StyledToolbar, TitleContainer, ProgressBar, StyledBoxContainer };
